import styles from "../styles/Contact.module.css";

function Contact() {
  return (
    <section id="contact" className={styles.contact}>
      <div className={styles.container}>
        <span className={styles.subtitle}>CONTACT</span>

        <h2>Reserve Your Table</h2>

        <p className={styles.description}>
          Book a table, ask a question, or plan your next night out at KitchenBar.
        </p>

        <div className={styles.wrapper}>
          {/* INFO SIDE */}
          <div className={styles.info}>
            <h3>Get in Touch</h3>

            <p>📍 Your Location, Cyprus</p>
            <p>📞 +357 XX XXX XXX</p>
            <p>✉ info@kitchenbar.com</p>

            <h3>Opening Hours</h3>
            <p>Mon - Thu: 17:00 - 00:00</p>
            <p>Fri - Sat: 17:00 - 02:00</p>
            <p>Sunday: 17:00 - 23:00</p>

            <a className={styles.callBtn} href="tel:+357XXXXXXXX">
              Call Now
            </a>
          </div>

          {/* FORM SIDE */}
          <form className={styles.form}>
            <input type="text" placeholder="Full Name" required />

            <input type="email" placeholder="Email" required />

            <input type="tel" placeholder="Phone Number" />

            <input type="date" />

            <select>
              <option>Number of Guests</option>
              <option>1-2</option>
              <option>3-4</option>
              <option>5-6</option>
              <option>7+</option>
            </select>

            <textarea placeholder="Special Requests" rows="5"></textarea>

            <button type="submit">Request Booking</button>
          </form>
        </div>

        {/* MAP */}
        <div className={styles.map}>
          <iframe
          title="KitchenBar Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d104383.80221012987!2d33.24338019726564!3d35.1567749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14de170132b1038f%3A0x656926109eb3c498!2zS2l0Y2hlbiBCYXIgLSDOkc6zzrvOsc69z4TOts65zqwgVmVudWU!5e0!3m2!1sen!2s!4v1783325406740!5m2!1sen!2s" 
          loading="lazy"></iframe>
        </div>
      </div>
    </section>
  );
}

export default Contact;